import React from 'react';
import PropTypes from 'prop-types';
import {CreateEditITRiskModal} from '@ey/canvascoreservices';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource} from '../../../util/utils';
import {clearErrors} from '../../../actions/erroractions';
import {getAllItProcessesWithoutPagination} from '../../../actions/ITProcess/itprocessactions';
import {createItRisk, updateItRisk} from '../../../actions/ITRisk/itriskactions';
import Utility from '../../../util/utilityfunctions';

export default function CreateEditITRiskModalWrapper(props) {
	const {
		itProcessId,
		isCreate,
		isEdit,
		showModal,
		setShowModal,
		entityId,
		entitySelector,
		parentEntitiesSelector,
		onClose,
		onEntityCreated,
		onEntityModified
	} = props;

	const [engagementId] = useSelector((state) => [state.engagementId]);

	let _entitySelector = entitySelector || ((state) => state.bodiesSpecial?.itRisks.byId[entityId]);
	let _parentEntitiesSelector = parentEntitiesSelector || ((state) => state.bodiesSpecial?.itProcesses);

	const itRisk = useSelector((state) => _entitySelector(state));
	const itProcesses = useSelector(_parentEntitiesSelector);

	const dispatch = useDispatch();

	const handleOnEntityCreated = (itRisk) => {
		let promise = Promise.resolve();

		if (onEntityCreated) {
			promise = onEntityCreated(itRisk);
		}
		return promise;
	};

	const handleOnEntityEdited = (itRisk) => {
		let promise = Promise.resolve();

		if (onEntityModified) {
			promise = onEntityModified(itRisk);
		}
		return promise;
	};

	const addItRisk = (data) => {
		return dispatch(createItRisk(engagementId, data)).then((itRisk) => handleOnEntityCreated(itRisk));
	};

	const editItRisk = (data) => {
		return dispatch(updateItRisk(engagementId, entityId, data)).then((itRisk) => handleOnEntityEdited(itRisk));
	};

	return (
		<>
			{isCreate && (
				<CreateEditITRiskModal
					getAllItProcessAction={() => {
						return dispatch(
							getAllItProcessesWithoutPagination(engagementId, null, {
								includePagination: false,
								includeITApp: true,
								includeControl: true,
								includeITRisk: true,
								includeITControl: true
							})
						);
					}}
					createITRiskAction={(data) => addItRisk(data)}
					itProcessId={itProcessId}
					itProcesses={itProcesses}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditITRiskLabels}
					onClose={() => {
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					theme={Utility.getTheme()}
				/>
			)}
			{isEdit && (
				<CreateEditITRiskModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					itProcessId={itProcessId}
					itProcesses={itProcesses}
					labels={currentResource.CreateEditITRiskLabels}
					itRiskId={itRisk?.id}
					itRiskDetails={itRisk}
					onClose={() => {
						dispatch(clearErrors());
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					manageITRiskAction={(data) => editItRisk(data)}
					theme={Utility.getTheme()}
				/>
			)}
		</>
	);
}

CreateEditITRiskModalWrapper.propTypes = {
	isCreate: PropTypes.bool,
	isEdit: PropTypes.bool,
	showModal: PropTypes.bool.isRequired,
	setShowModal: PropTypes.func.isRequired,
	entityId: PropTypes.number,
	onClose: PropTypes.func
};
